export const TOOLBAR_TYPES = {
  FULL: "FULL",
  MEDIUM: "MEDIUM",
};

Object.freeze(TOOLBAR_TYPES);
